export default __webpack_public_path__ + "static/media/kitchen5-afterE-480w.489ce5df.png";